import React from 'react';
import footnoteConstants from '../constants/footnotes';

const localizedText = footnoteConstants['en-US'];

const Footnotes = () => (
  <div className='footnotes-container'>
    <h3>
      Notes
    </h3>
    <ol>
      {Object.values(localizedText).map((text, i) => (
        <li key={`footnote-${i + 1}`}>
          {text}
        </li>
      ))}
    </ol>
  </div>
);

export { Footnotes };
